import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootStateType } from '@/core/store/store';

const initialState: { selectedSchoolYear: number } = {
  selectedSchoolYear: 0,
};
const SCHEDULES_STORE_KEY = 'schedules';

const schedulesSlice = createSlice({
  name: 'schedules',
  initialState,
  reducers: {
    setSelectedSchoolYear(state, action: PayloadAction<number>) {
      state.selectedSchoolYear = action.payload;
    },
  },
});

const selectSchoolYear = (state: RootStateType) => state.schedules.selectedSchoolYear;

export const { setSelectedSchoolYear } = schedulesSlice.actions;
export default schedulesSlice.reducer;
export { initialState, SCHEDULES_STORE_KEY, selectSchoolYear };
